import { render, staticRenderFns } from "./Abnormality.vue?vue&type=template&id=79d1b928&scoped=true&"
import script from "./Abnormality.vue?vue&type=script&lang=js&"
export * from "./Abnormality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d1b928",
  null
  
)

export default component.exports